import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

// Global Types
import { AppState } from 'services/types';

// Components
// @ts-ignore
import EventTableRow from './components/EventTableRow';

// Styles
import '../../styles.scss';

// Selectors
// @ts-ignore
import { selectUuids } from '../../selectors';

interface ConnectedProps {
    uuids?: string[];
}

type Props = ConnectedProps;

export class EventTableRows extends React.PureComponent<Props> {
    render(): React.ReactElement | React.ReactElement[] {
        const { uuids } = this.props;
        if (!uuids || !uuids.length) {
            return (
                <Table.Row colSpan="6" textAlign="center">
                    <Table.Cell
                        colSpan="6"
                        className="events-table-cell-padding"
                    >
                        {'There are no forecasts to schedule. '}
                        <Link to="/organization/harvest/bin-forecasts">
                            Edit Forecasts
                        </Link>
                    </Table.Cell>
                </Table.Row>
            );
        }
        return uuids.map((uuid) => (
            <EventTableRow key={uuid} harvestEventUuid={uuid} />
        ));
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    uuids: selectUuids
});

export default connect(mapStateToProps)(EventTableRows);
